/**
 * get/set/delete
 */
import { formatOptApi, log } from '..';
import { PROJECT_SRV } from '../../../../api/config';
import {
  FieldOptAPIReqScenes,
  FieldOptSource,
  IAPIProtractedRes,
  IFieldOptAPI,
} from '../../model';

const API_GET_PATH = `${PROJECT_SRV}/GetFrontDefinedData`;
const API_SET_PATH = `${PROJECT_SRV}/PostFrontDefinedData`;

// 默认的持久接口配置
const PROTRACTED_REMOTE_CONFIG: IFieldOptAPI = {
  kind: FieldOptSource.api,
  api: {
    kind: FieldOptAPIReqScenes.normal,
    path: API_GET_PATH,
    method: 'POST',
  },
  data: [
    // {
    //   key: 'module',
    //   is_shown: false,
    // },
    // {
    //   key: 'title',
    //   is_shown: true,
    // },
    // {
    //   key: 'scheduled',
    //   is_shown: true,
    // }
  ],
};

const mergeDefaultApi = (apiConfig?: IFieldOptAPI, path?: string) => {
  const api = Object.assign({}, PROTRACTED_REMOTE_CONFIG.api, {
    path: path || API_GET_PATH,
  });
  return Object.assign({}, PROTRACTED_REMOTE_CONFIG, apiConfig, { api });
};

export async function getProtractedData<T>(
  guid: string | string[],
  apiConfigParams?: IFieldOptAPI
): Promise<ReadonlyArray<IAPIProtractedRes<T>>> {
  const apiConfig = mergeDefaultApi(apiConfigParams);
  if (apiConfig.api.kind === FieldOptAPIReqScenes.normal) {
    const body = Object.assign({}, apiConfig.api.body, {
      keys: typeof guid === 'string' ? [guid] : guid,
    });
    Object.assign(apiConfig.api, { body });
  }
  const data = await formatOptApi(apiConfig);
  if (Array.isArray(data)) {
    return data.map((item: any) => {
      let value = [];
      try {
        value = JSON.parse(item.value);
      } catch (err) {
        log.error('getProtractedData JSON.parse error', err);
      }
      return Object.assign({}, item, {
        value,
      });
    });
  }
  return [];
}

export async function setProtractedData<T>(
  guid: string,
  data: ReadonlyArray<T>,
  apiConfigParams?: IFieldOptAPI
) {
  const apiConfig = mergeDefaultApi(apiConfigParams, API_SET_PATH);
  if (apiConfig.api.kind === FieldOptAPIReqScenes.normal) {
    const body = Object.assign({}, apiConfig.api.body, {
      key: guid,
      value: JSON.stringify(data),
    });
    Object.assign(apiConfig.api, { body });
  }

  // 不管成功失败, 不会提示给用户
  await formatOptApi(apiConfig);
  return true;
}
